import {
  EnumMultiDropdown,
  EnumMultiDropdownCreateForm,
  PureEnumMultiDropdownField,
  PureEnumMultiDropdownFieldProps,
} from './EnumMultiDropdown';
import { ISSUE_ATTRIBUTE_NAMES } from '../../constants';
import { translate } from '../../helpers';

const fieldName = ISSUE_ATTRIBUTE_NAMES.DISCIPLINE; // 'discipline'

export const DisciplineFormikField = () => (
  <EnumMultiDropdown
    fieldName={fieldName}
    label={translate(`new.${fieldName}`)}
    placeholder={translate(`new.placeholder.${fieldName}`)}
    id={fieldName}
    clearable
  />
);

export const DisciplineInCreateForm = () => (
  <EnumMultiDropdownCreateForm
    fieldName={fieldName}
    label={translate(`new.${fieldName}`)}
    placeholder={translate(`new.placeholder.${fieldName}`)}
    id={fieldName}
    clearable
  />
);

export const DisciplineField = ({
  value,
  onChange,
}: Pick<PureEnumMultiDropdownFieldProps, 'value' | 'onChange'>) => (
  <PureEnumMultiDropdownField
    fieldName={fieldName}
    label={translate(`new.${fieldName}`)}
    placeholder={translate(`new.placeholder.${fieldName}`)}
    id={`inline-${fieldName}`}
    value={value}
    onChange={onChange}
    clearable
  />
);
